import { convertToLocalStyle, getColumnSolidBorderStyle, dateFilterStyle, glyphIconStyle } from '@bingads-webui-campaign-react/common-styles';
import { getTableStyles, getTableGlobalStyles } from '@bingads-webui-campaign-react/grid-view-wrapper';
import { merge } from '@bingads-webui/primitive-utilities';

const getKcalendarStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  position: 'relative',
  display: 'inline-block',
  // width: '16.917em',
  overflow: 'hidden',

  '& td, .k-link': {
    textDecoration: 'none',
  },

  '& .k-action-link': {
    textDecoration: 'underline',
  },

  '& .k-header, .k-footer': {
    position: 'relative',
    textAlign: 'center',
    zoom: 1,
  },

  '& .k-nav-prev, .k-nav-next': {
    position: 'absolute',
    top: '0.16666em',
    lineHeight: '1.8333em',
    height: '1.8333em',
  },

  '& .k-nav-prev': {
    left: '1%',
  },

  '& .k-nav-next': {
    right: '1%',
  },

  '& .k-content': {
    float: 'left',
    borderSpacing: 0,
    width: '100%',
    height: '14.167em',
    borderWidth: 0,
    margin: 0,
    tableLayout: 'fixed',
    textAlign: 'right',
    outline: 0,
  },

  '& .k-header': {
    '& .k-icon': {
      verticalAlign: 'middle',
      height: '1.8333em',
      width: '1.8333em',
    },

    '& .k-i-arrow-w': {
      fontFamily: iconFontFamily,
    },

    '& .k-i-arrow-w:before': {
      content: '"\\E76B"',
    },

    '& .k-i-arrow-e': {
      fontFamily: iconFontFamily,
    },

    '& .k-i-arrow-e:before': {
      content: '"\\E76C"',
    },

    '& .k-nav-fast': {
      display: 'inline-block',
      width: '75%',
      height: '1.8333em',
      lineHeight: '1.8333em',
      margin: '0.16666em -0.08333em 0.3333em 0',
    },
  },

  '& th': {
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    padding: '.4em .3em .4em .3em',
    fontWeight: 'normal',
    cursor: 'default',
  },

  '& td': {
    padding: '0.08333em',
    cursor: 'pointer',
  },

  '& .k-state-focus': {
    borderStyle: 'dotted',
    borderWidth: '0.08333em',
    padding: 0,
  },

  '& .k-other-month': {
    pointerEvents: 'none',
    cursor: 'default',
    textDecoration: 'none',
    color: 'gray',
  },

  '& .k-content .k-link': {
    display: 'block',
    overflow: 'hidden',
    minHeight: '1.8333em',
    lineHeight: '1.8333em',
    padding: '0 .45em 0 .1em',
  },

  '& .k-meta-view .k-link': {
    padding: '.25em 0 .3em',
    textAlign: 'center',
  },

  '& .k-footer': {
    clear: 'both',

    '& .k-nav-today, > .k-state-disabled': {
      display: 'block',
      height: '100%',
      padding: '.5em 0',
    },
  },

  '& tbody td .k-state-disabled': {
    color: '#a2a2a2',
    padding: '0 0.45em 0 0.1em',
  },

  '& .k-nav-today:hover': {
    textDecoration: 'underline',
  },

  '& .k-link:hover': {
    textDecoration: 'underline',
  },

  ...convertToLocalStyle(glyphIconStyle({ palette })),
});

export const getFeedStatusStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '@global': {
    '.bingads-campaign-react-sub-page-menu': {
      '& .compared-date-range-picker': {
        display: 'none',
      },
    },

    '.k-calendar-container': {
      width: '203px',
      border: '2px solid #ccc',
      backgroundColor: palette.white,

      '& .k-calendar': getKcalendarStyle({ palette, iconFontFamily }),
    },

    '.k-list-container': {
      overflow: 'auto',
      backgroundColor: palette.white,
      width: 86,
      fontSize: 12,

      '& ul': {
        listStyle: 'none',
        padding: 0,

        '& li': {
          padding: 5,
        },
      },
    },
  },

  FeedStatus: merge({
    marginLeft: '32px',
    marginTop: '32px',
    display: 'flex',
    overflow: 'auto',
    flex: '1 0 1px',
    flexDirection: 'column',

    '& .intelligence-feed-status-name-container': {
      marginBottom: '20px',
    },

    '& .intelligence-feed-status-toolbar-container': {
      marginLeft: '15px',
      marginBottom: '15px',
    },

    '& .table-bordered': {
      border: 0,
    },

    '& .helpbutton:before': {
      content: '"\\E9CE"',
      fontFamily: iconFontFamily,
      verticalAlign: 'middle',
    },

    '& .helpbutton': {
      fontSize: 15,
      fontWeight: 'normal',
      marginLeft: 7,
    },

    '& .intelligence-feed-status-grid': getTableStyles(_, { palette }),
    ...getColumnSolidBorderStyle(0, 2),
    ...dateFilterStyle({ palette }),
  }, convertToLocalStyle(getTableGlobalStyles(_, { palette }))),
});
